export const worker = new Worker(
  new URL("./downloadManager.worker", import.meta.url),
  { type: "module" }
);
